<template>
  <section
    class="features-tiles section center-content-mobile"
    :class="[
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
    ]"
  >
    <div class="container">
      <div
        class="features-tiles-inner section-inner"
        :class="[
          topDivider && 'has-top-divider',
          bottomDivider && 'has-bottom-divider',
        ]"
      >
        <c-section-header :data="sectionHeader" class="center-content" />
        <div class="tiles-wrap" :class="[pushLeft && 'push-left']">
          <div class="tiles-item">
            <div class="tiles-item-inner">
              <div class="features-tiles-item-header">
                <div
                  class="features-tiles-item-image mb-12 reveal-from-right"
                  data-reveal-container=".tiles-item"
                >
                  <c-image
                    :src="require('@/assets/images/feature-tile-icon-07.svg')"
                    alt="Feature tile icon 01"
                    :width="72"
                    :height="72"
                  />
                </div>
              </div>
              <div class="features-tiles-item-content">
                <h4
                  class="mt-0 mb-8 reveal-from-right"
                  data-reveal-container=".tiles-item"
                  data-reveal-delay="100"
                >
                  ABF Licensed &middot; DAFF Accredited
                </h4>
                <p
                  class="m-0 text-sm reveal-from-right"
                  data-reveal-container=".tiles-item"
                  data-reveal-delay="200"
                >
                  Our in-house customs broker is licensed by the Australian Border Force, with DAFF accreditation for biosecurity entries.
                </p>
              </div>
            </div>
          </div>

          <div class="tiles-item">
            <div class="tiles-item-inner">
              <div class="features-tiles-item-header">
                <div
                  class="features-tiles-item-image mb-12 reveal-from-right"
                  data-reveal-container=".tiles-item"
                  data-reveal-delay="100"
                >
                  <c-image
                    :src="require('@/assets/images/feature-tile-icon-08.svg')"
                    alt="Feature tile icon 02"
                    :width="72"
                    :height="72"
                  />
                </div>
              </div>
              <div class="features-tiles-item-content">
                <h4
                  class="mt-0 mb-8 reveal-from-right"
                  data-reveal-container=".tiles-item"
                  data-reveal-delay="200"
                >
                  2,200 m&sup2; Own Warehouse in Perth
                </h4>
                <p
                  class="m-0 text-sm reveal-from-right"
                  data-reveal-container=".tiles-item"
                  data-reveal-delay="300"
                >
                  Self-owned facility with container ramps, forklifts and secure storage — from parcels to oversized cargo.
                </p>
              </div>
            </div>
          </div>

          <div class="tiles-item">
            <div class="tiles-item-inner">
              <div class="features-tiles-item-header">
                <div
                  class="features-tiles-item-image mb-12 reveal-from-right"
                  data-reveal-container=".tiles-item"
                  data-reveal-delay="200"
                >
                  <c-image
                    :src="require('@/assets/images/feature-tile-icon-09.svg')"
                    alt="Feature tile icon 03"
                    :width="72"
                    :height="72"
                  />
                </div>
              </div>
              <div class="features-tiles-item-content">
                <h4
                  class="mt-0 mb-8 reveal-from-right"
                  data-reveal-container=".tiles-item"
                  data-reveal-delay="300"
                >
                  中英双语 Bilingual Service
                </h4>
                <p
                  class="m-0 text-sm reveal-from-right"
                  data-reveal-container=".tiles-item"
                  data-reveal-delay="400"
                >
                  Mandarin and English support across quoting, customs and delivery — nothing lost in translation.
                </p>
              </div>
            </div>
          </div>

       
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { SectionTilesProps } from "@/utils/SectionProps.js";
import CSectionHeader from "@/components/sections/partials/SectionHeader.vue";
import CImage from "@/components/elements/Image.vue";

export default {
  name: "CFeaturesTiles",
  components: {
    CSectionHeader,
    CImage,
  },
  mixins: [SectionTilesProps],
  data() {
    return {
      sectionHeader: {
        title: "Why Line-1",
        paragraph: "",
      },
    };
  },
};
</script>